import { Component, TemplateRef, ViewChild } from '@angular/core';
import { ICustomCellComponent } from '@shared/modules/data-table/classes/ICustomCellComponent';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-checkbox-table-cell',
  templateUrl: './checkbox-table-cell.component.html',
  styleUrls: ['./checkbox-table-cell.component.scss'],
})
export class CheckboxTableCellComponent implements ICustomCellComponent {
  @ViewChild(TemplateRef, { static: true }) cellTemplate: TemplateRef<unknown>;

  checkBox = new FormControl();
}
